import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UiModule } from '../../ui.module';

import { LogoutTimeoutComponent } from './../../../authorization/logout-timeout/logout-timeout.component';
import { LossSessionComponent } from './../../../authorization/loss-session/loss-session.component';
import { CommonAppModule } from './../../../common/common-app.module';
import { SvgCommonModule } from './../../../shared/svg/svg-common.module';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { NotificationStickerComponent } from './components/notification-sticker/notification-sticker.component';
import { UserBlockComponent } from './components/user-block/user-block.component';
import { HeaderComponent } from './header.component';
import { HeaderService } from './header.service';

@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		RouterModule,
		UiModule,
		SvgCommonModule,
		LogoutTimeoutComponent,
	],
	declarations: [
		HeaderComponent,
		MainMenuComponent,
		UserBlockComponent,
		LossSessionComponent,
		NotificationStickerComponent,
	],
	exports: [
		HeaderComponent,
		MainMenuComponent,
		UserBlockComponent,
		LossSessionComponent,
		NotificationStickerComponent,
	],
	providers: [HeaderService],
})

export class HeaderModule { }
